import React from "react";
import { useSelector } from 'react-redux';
import TextInput from "../../../../components/TextInput";
import CustomIconButton from "../../../../components/CustomIconButton";
import CheckboxButton from "../../../../components/CheckboxButton";


const ReasonSection = ({ 
    reasonsListFull, 
    selectedOptions, 
    setSelectedOptions, 
    dataOtherReason, 
    setDataOtherReason, 
    setUnselectedOptions,
    setDisplay 
    }: any) => {
    const { talent, errors } = useSelector((state: any) => state.talentMypage)

    const handleCheckboxReason = (item: any) => {
        const { value, checked } = item;
        setSelectedOptions((prev) => checked ? [...prev, value] : prev.filter((option) => option !== value));
        setUnselectedOptions((prev) => checked ? prev.filter((option) => option !== value) : [...prev, value]);
        setDisplay(true)
    };

    const handleChangeOtherReason = (e: any, idx: any) => {
        const newDataOtherReason = [...dataOtherReason];
        newDataOtherReason[idx] = e.target.value;
        setDataOtherReason(newDataOtherReason);
        setDisplay(true)
    };

    const handleAddOtherReason = () => {
        setDataOtherReason((prevDataOtherReason) => [...prevDataOtherReason, ""]);
    }

    return (
        <>
            <div className="flex flex-wrap gap-4 items-center mb-4">
                <p className="alu-text-base-2 text-base font-bold">
                退職理由
                </p>
            </div>
            <div className="mb-4 flex flex-wrap gap-4">
                {reasonsListFull?.map((item: any, idx: any) => (
                <div className="flex gap-2 items-center" key={idx}>
                    <CheckboxButton
                    id={"reason" + idx}
                    name="reason[]"
                    value={selectedOptions.includes(item)}
                    label={item}
                    onChange={() => handleCheckboxReason({ value: item, checked: !selectedOptions.includes(item) })}
                    />
                </div>
                ))}
            </div>
            {dataOtherReason.map((item, idx) => (
                <div className="flex items-center justify-between gap-[0.625rem] mb-4" key={idx}>
                <div className="flex-1">
                    <TextInput
                    size="md"
                    name="otherReason[]"
                    placeholder="その他の退職理由を入力"
                    value={item}
                    onChange={(e:any) => handleChangeOtherReason(e, idx)}
                    />
                </div>
                <CustomIconButton
                    customStyle="shrink-0"
                    onClick={() => {
                    setDataOtherReason(prev => prev.filter((_,index) => index !== idx))
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M200-440v-80h560v80H200Z"/></svg>
                </CustomIconButton>
                </div>
            ))}
            {errors && errors?.reason_resignation && <p className='alu-text-error text-sm mt-1 mb-3'>※{errors?.reason_resignation}</p>}
            <div className="">
                <button
                className="flex items-center gap-1 p-1 hover:bg-[#FFF3E5] rounded"
                onClick={handleAddOtherReason}
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clipPath="url(#clip0_13284_8548)">
                    <path
                        d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                        fill="#FF861A"
                    />
                    </g>
                    <defs>
                    <clipPath id="clip0_13284_8548">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                    </defs>
                </svg>
                <span className="alu-text-title text-sm">追加する</span>
                </button>
            </div>
        </>
    )
};

export default ReasonSection;